export default __webpack_public_path__ + "static/media/waves-white.56607573.svg";